<template>
  <div class='detailPage'>
    <div class='headerClass'>{{ headerTitle }}</div>
    <div class='contentPage'>
      <div class='tabClass'>
        <el-tabs v-model='activeName' type='card'>
          <el-tab-pane :label="$t('business.carrier_detail')" name='carrierDetail'></el-tab-pane>
          <el-tab-pane :label="$t('public.event')" name='ExPage'></el-tab-pane>
          <!--<el-tab-pane :label="$t('business.record_point')" name='carrierLogpoint'></el-tab-pane>-->
          <!--<el-tab-pane :label="$t('integration.alarm_switch')" name='AlarmLog'></el-tab-pane>-->
        </el-tabs>
      </div>

      <keep-alive>
        <component :detailObj='detailObj' :getCarrierType='getCarrierType' :getCarrierStatus='getCarrierStatus'
                   :is='activeName' :deviceArray='deviceArray' :isShowEdit2.sync='isShowEdit2'
                   @back='isShowEdit2 = true'
                   @edit='isShowEdit2 = false' @getList='getDetailInit' />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { carrierDetail } from '@/api/modules/carrier.js'
import CarrierDetail from '@/pages/business/components/detail/carrierDetail/CarrierDetail'
import carrierAbnormal from './carrierAbnormal.vue'
import carrierLogpoint from './carrierLogpoint.vue'
import { equiTypeConvert } from '@/utils/convert'
import AlarmLog from '@/pages/journal/alarmLog.vue'
import ExPage from './carrierExPage.vue'

export default {
  components: {
    carrierAbnormal,
    CarrierDetail,
    AlarmLog,
    ExPage
  },
  // beforeRouteEnter(to, from, next) {
  //   document.title = to.query['keycode']
  //   next()
  // },
  watch: {
    // 报警触发弹窗显示状态改变
    // isAlarm() {
    //     if (!this.isAlarm) {
    //         this.getDetailInit();
    //     }
    // }
  },
  data () {
    return {
      equiTypeConvert,
      headerTitle: '',

      activeName: 'carrierDetail',

      isShowEdit2: true,
      showEditImg: false,

      detailObj: {},
      getCarrierStatus: [],
      getCarrierType: {},
      // 其他内容
      activeName2: 'carrierDevice',
      tabArray: [
        {
          label: 'business.carrier_equipment',
          name: 'carrierDevice'
        },
        {
          label: 'public.attribute',
          name: 'Attribute'
        }
      ],
      // 设备下拉数据
      deviceArray: [],
      iconArray: ['iconfont icon-chuanganqi1', 'iconfont icon-wangguan', 'iconfont icon-lcd', 'el-icon-s-operation'],

      carrierImg: ''
    }
  },
  created () {
    this.headerTitle = this.$route.query.keycode + '-' + $t('public.detail')
    this.getDetailInit();
    this.getCarrierStatus = JSON.parse(sessionStorage.getItem('getCarrierStatus') || '[]')
    this.getCarrierType = JSON.parse(sessionStorage.getItem('getCarrierType') || '[]')
  },
  methods: {
    // 工具函数 将两个数组中相同的id进行合并
    mergeArray (arr1 = [], arr2 = [], idKeys = ['id', 'id'], mergeAttr = {}) {
      // 数组对象化 便于检索 空间换时间

      const arr1Obj = {}
      const arr2Obj = {}

      for (let i = 0; i < arr1.length; i++) {
        const curId = arr1[i][idKeys[0]]
        arr1Obj[curId] = arr1[i]
      }
      for (let i = 0; i < arr2.length; i++) {
        const curId = arr2[i][idKeys[1]]
        arr2Obj[curId] = arr2[i]
      }

      const maxLen = Math.max(arr1.length, arr2.length)
      const result = []

      // 处理合并的属性 如果是函数需要执行
      const keys = Object.keys(mergeAttr)
      // 用于存储待执行的函数的key
      const func = []
      keys.forEach(key => {
        if (typeof mergeAttr[key] === 'function') {
          func.push(key)
        }
      })
      for (let i = 0; i < maxLen; i++) {
        if (arr1[i]) {
          const curId = arr1[i][idKeys[0]]
          const newMerge = {}
          // 处理函数
          func.forEach(key => {
            newMerge[key] = mergeAttr[key].call(arr1[i]) || 'un'
          })
          result.push({
            ...arr1Obj[curId],
            ...(arr2Obj[curId] || {}),
            ...newMerge,
            ...mergeAttr
          })
        } else {
          const curId = arr2[i][idKeys[1]]
          result.push({
            ...(arr1Obj[curId] || {}),
            ...arr2Obj[curId],
            ...mergeAttr
          })
        }
      }
      // 当监测点被删除锚点却存在， 会出现问题  这里过滤一下
      return result.filter(item => {
        if (typeof item.name === 'function') return false
        return true
      })
    },
    getDetailInit () {
      const {
        type,
        id
      } = this.$route.query
      carrierDetail(type, id)
        .then(({ result }) => {
          if (result) {
            // 获取设备对应的图片
            this.detailObj = result || {}
            document.title = this.headerTitle = result.keycode
            // 这里原本是i18n国际化
            // this.detailObj.typeName = typeName;
          }
        })
        .then(() => {
        })
    },
    handleEdit () {
      this.isShowEdit = !this.isShowEdit
    },
    handleEdit2 () {
      this.isShowEdit2 = !this.isShowEdit2
    },

    /** 报警设置 拿去之前的东西 */
    // goRouter() {
    //     let { href } = this.$router.resolve({
    //         path: '/alarmGroup',
    //         query: {
    //             scene_id: String(this.detailObj.scene_id),
    //             batchCall: true,
    //             arr_id: this.detailObj['id'],
    //             type: this.getCarrierType['id'],
    //             alarm_switch: this.detailObj.alarm_switch
    //         }
    //     });
    //     window.open(href, 'newwindow', 'height=800,width=1280,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
    // },
    /** 切换tab时，移动到第一个tab位置 */
    handleClick (row) {
      // 先删除后追加 这里就不做预处理了 预处理的话就判断当前的是否一致
      const newArr = this.tabArray.splice(row.index, 1)
      this.tabArray.unshift(newArr[0])
      this.isShowEdit2 = true
      this.activeName2 = row.name
    },
    /** 监测点图片点击设置 */
    detailImgSetting () {
      this.showEditImg = true
    }
  },
  mounted () {
    // 初始化tab
  }
}
</script>

<style lang='scss' scoped>
.detailPage {
  height: 100%;
  width: 100%;

  .headerClass {
    height: 60px;
    line-height: 60px;
    padding-bottom: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
  }

  .contentPage,
  .otherContent {
    padding: 15px;
    height: calc(100% - 60px);
  }

  .tabClass {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--primary-color);
    margin-bottom: 15px;

    ::v-deep .el-tabs__header {
      margin-bottom: 0px;
    }
  }

  i {
    font-size: 18px;

    margin-left: 10px;
    cursor: pointer;
    color: #ccc;
  }

  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: var(--primary-color);
    color: #fff;
  }

  .img-content {
    width: 400px;
    height: 400px;

    img {
      width: 100%;
      object-fit: contain;
      object-position: left top;
    }
  }

  .bottomContent {
    height: 400px;
  }

  ::v-deep .button-icon {
    margin: 0;
    color: white;
    font-size: 14px;

    margin-right: 5px;
  }
}
</style>
